// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import expertEntity from './entities/expert.json';
import expertMenu from '../pages/expert/menu.json';
import expertFullForm from '../pages/expert/forms/full.json';
import expertContextForm from '../pages/expert/forms/context.json';
import expertMiniForm from '../pages/expert/forms/mini.json';
import expertLookupForm from '../pages/expert/forms/lookup.json';
import expertTableView from '../pages/expert/views/table.json';
import expertStagesView from '../pages/expert/views/stages.json';
import expertBacklogView from '../pages/expert/views/backlog.json';
import expertSplitView from '../pages/expert/views/split.json';
import expertCardsView from '../pages/expert/views/cards.json';
import expertCalendarView from '../pages/expert/views/calendar.json';
import expertDashboardView from '../pages/expert/views/dashboard.json';

/** Тип запису «Висновок» зі сторінками пакета: меню, форми та подання з pages/expert/. */
export const expertDefinition: IRecordTypeDefinition = {
  ...expertEntity,
  views: assembleViewSet({
      table: expertTableView,
      stages: expertStagesView,
      backlog: expertBacklogView,
      split: expertSplitView,
      cards: expertCardsView,
      calendar: expertCalendarView,
      dashboard: expertDashboardView,
  }),
  form: expertFullForm,
  forms: { full: expertFullForm, context: expertContextForm, mini: expertMiniForm, lookup: expertLookupForm },
  menu: expertMenu,
} as IRecordTypeDefinition;
